import React from 'react';
import { CartProvider } from '../../contexts/cart-context';
import '../../styles/components/layout.scss';
import Footer from './Footer';
import Header from './Header';

type LayoutProps = {
  children: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  return (
    <>
      <CartProvider>
        <Header />
        <main className='main'>{children}</main>
      </CartProvider>
      <Footer />
    </>
  );
};

export default Layout;
